import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import router from '@/router';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router'; // 画面パラメーター取得用

// Ionic
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

// スプラッシュスクリーン
import { SplashScreen } from '@capacitor/splash-screen';

// Google Maps
import { Loader } from 'google-maps';

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';  // 共通変数
import * as Tools from '@/components/00/Tools'; // 共通ツール
import * as GFunc from '@/components/00/Common00';  // 共通メソッド
import * as DB from '@/components/00/db/DbInit';  // DB初期化用メソッド

// キニッタ！専用
import * as LFunc from '@/components/05/Common05001'; // キニッタ！専用メソッド
import * as DLink from '@/components/05/DynamicLink05001'; // ダイナミックリンク

// SQLite用
import { CapacitorSQLite, SQLiteConnection } from "@capacitor-community/sqlite"


/**
 * アプリ初期化処理（同期）
 */
/*
onMounted(async ()=>
{
  try 
  {
    if ( GFunc.isDebugEnabled() ) {console.log("App onMounted()");}     


  } catch (e) {
    console.log(`Error: ${e}`);
    throw new Error(`Error: ${e}`)
  }
})
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// Vue

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet), { id: "router" })
    ]),
    _: 1
  }))
}
}

})